import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Notification } from 'src/utils';
import { ICreateSupplierInput } from 'src/interfaces/suppliers';
import { IProps } from './new.type';

const useSuppliers = (props: IProps) => {
  const navigate = useNavigate();

  const [sending, setSending] = useState(false);

  const handleSubmit = async (input: ICreateSupplierInput) => {
    setSending(true);

    try {
      const data = await props.createSupplier(input);

      if (!!data) {
        Notification.success({
          title: 'Ok',
          message: 'Fornecedor cadastrado com sucesso!',
        });

        navigate(-1);
      }
    } catch (err: any) {
      console.dir(err, 'erro');
      return false;
    } finally {
      setSending(false);
    }
  };

  return {
    handleSubmit,
    sending,
  };
};

export default useSuppliers;
